module.exports = __webpack_public_path__ + "static/media/logo.f9291862.svg";